import { FC, PropsWithChildren } from 'react'
import styled from 'styled-components'

import LockIcon from '../../../components/icons/Lock'

const HintWrapper = styled.div`
  display: flex;
  align-items: center;

  font-size: ${({ theme }) => theme['-ds-font-size-xs']['font-size'].value};
  font-weight: ${({ theme }) => theme['-ds-font-size-xs']['font-weight'].value};
  color: ${({ theme }) => theme['-ds-neutral-500'].value};

  svg {
    height: 18px;
    margin-right: 10px;
  }
`

export const VisibilityHint: FC<PropsWithChildren> = ({ children }) => (
  <HintWrapper>
    <LockIcon />
    {/* @ts-ignore -- not typed yet */}
    {children}
  </HintWrapper>
)
